import { AxiosRequestConfig } from 'axios';

export async function withRetry(
  instance: any,
  url: string,
  config: AxiosRequestConfig,
  retryDelay: number = 3000,
  retryStatus: number = 202,
  retriesLimit: number = Infinity
) {
  let play = true;
  let currentRetry = 0;

  while (play && currentRetry < retriesLimit) {
    currentRetry++;

    const response = await instance(url, config);

    if (response.status !== retryStatus) {
      play = false;
      return response;
    }

    /*
      this code aims to wait retryDelay timeout
      before go to the next iteration?
      it is just a postponed run  */
    await new Promise(resolve => {
      setTimeout(() => {
        resolve('resolved');
      }, retryDelay);
    });
  }

  return Promise.reject('');
}
